var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['d-flex dash-card-icon rounded', `bg-opacity-${_vm.variant}`, `border border-opacity-${_vm.variant} border-width-2`]},[_c('b-icon',_vm._b({attrs:{"icon":_vm.icon,"variant":_vm.variant,"font-scale":_vm.fontScale}},'b-icon',[{iconFontScale: !_vm.iconFontScale ? false : _vm.iconFontScale}],false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }